<div class="person">
  <span class="person__avatar" aria-hidden="true">
    @if (avatarUrl() && !avatarFailed()) {
      <img [src]="avatarUrl()" alt="" (error)="avatarFailed.set(true)" />
    } @else {
      {{ initials() }}
    }
  </span>
  <span class="person__text">
    <span class="person__name" appTitleIfTruncated>{{ displayName() }}</span>
    @if (name().trim() && email()) {
      <span class="person__email" appTitleIfTruncated>{{ email() }}</span>
    }
  </span>
  @if (badge()) {
    <app-status-badge class="person__badge">{{ badge() }}</app-status-badge>
  }
  <span class="person__end"><ng-content /></span>
</div>
